import './public-path'

import Vue from 'vue'
import I18n from 'vue-i18n'
import Router from 'vue-router'
import { Store } from 'vuex'

import { install as installFilters } from '@utils/filters'

import { install } from '@/install'
import { createApp } from '@/app'
import appComponents from './js/components'
import iconComponents from './js/icons'
import './js/validation'
import { createCustomRules } from './js/validation/rules'
import { navigationList } from './navigationList'
import './js/directives'
import './styles/index.sass'

Vue.config.productionTip = false

Vue.use(install)
Vue.use(installFilters)
Vue.use(appComponents)
Vue.use(iconComponents)

const { app } = createApp({
  Vue,
  I18n,
  Router,
  Store,
})

app.$mount('#app')

createCustomRules(app)

export const navigation = navigationList(app)
